import { ModelConfigParams, lungChecklistMFG, lungChecklistQC } from "./model-config-params";

export const lung: ModelConfigParams = {
  bodyParts: [
    'tumour',
    'airwayWithDetail',
    'veinWithDetailAndUncertain',
    'arteryWithDetailAndUncertainAndSegments',
    'lobeRightInferior',
    'lobeRightMedial',
    'lobeRightSuperior',
    'lobeLeftInferior',
    'lobeLeftSuperior',
    'bone',
    'aorta',
    'heartWithChambers',
    'oesophagus',
    'unknown',
    'tumourMargin',
  ],
  tissueHotkeys: {
    tumour: 'q',
    artery: 'w',
    vein: 'e',
    airway: 'r',
    arteryUncertain: "t",
    arteryDetail: "y",
    veinUncertain: "u",
    veinDetail: "i",
    airwayDetail: "o",
    unknown: "p",
    lobeLeftSuperior: "alt + q",
    lobeLeftInferior: "alt + w",
    lobeRightSuperior: "alt + r",
    lobeRightMedial: "alt + t",
    lobeRightInferior: "alt + u",
  },
  checklist: lungChecklistMFG,
  checklistQC: lungChecklistQC,
  defaultIntensityRange: [-1000, 300],
  internal: true,
}
